import * as service from "../service";
import type { ServiceResponse } from "../types";
import type { BusinessPlanType } from "./getBusinessPlan";

type ChangeBusinessPlanParams = {
  plan_type: BusinessPlanType;
};

/**
 * Switch to the yearly plan. A subscribed business keeps the
 * current period and the new rate starts at the next renewal, so the API
 * returns the plan that is still running plus the one now queued.
 * Backend: POST /api/business/plan/change
 */
export const ChangeBusinessPlanAPI = async ({
  plan_type,
}: ChangeBusinessPlanParams): Promise<
  ServiceResponse<{
    plan_type?: BusinessPlanType | string;
    pending_plan_type?: BusinessPlanType | string | null;
    renews_on?: string | null;
  }>
> => {
  try {
    const resp = (await service.call(
      "POST",
      "api/business/plan/change",
      { plan_type },
    )) as ServiceResponse<{
      plan_type?: BusinessPlanType | string;
      pending_plan_type?: BusinessPlanType | string | null;
      renews_on?: string | null;
    }>;
    return resp;
  } catch (err) {
    console.error(`ChangeBusinessPlanAPI ${err}`);
    return { status: -1, error: err };
  }
};
